import { RootState } from "apps/store";

export const tooltipInfoSelector = (state: RootState) => state.tooltipInfo.tooltipInfo
